import { pickBy } from 'lodash';
export const getArticleContents = (state, articleId) => {
    return pickBy(state.articleContents.resources, (articleContent) => articleContent.article === articleId);
};
